// Julkiset kirjastot
import React, { useState, useEffect, useContext } from "react";
import IconButton from "@mui/material/IconButton";
import Autocomplete from '@mui/material/Autocomplete';
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

// Sovelluksen komponentit
import { ConfirmCancelDialog } from './ConfirmCancelDialog';
import { LanguageContext } from './LanguageContext';
import { BuildOptions } from "./Common";

// Entiteettikohtaiset vakiot

// Funktio
export const KoodiAdd = ({ lookupLists, onAdd }) => {

    // Toistuvat muuttujat
    const { dictionary } = useContext(LanguageContext);
    const [rowData, setRowData] = useState({});
    const [open, setOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [jotainMuuttui, setJotainMuuttui] = useState(false);

    // Entiteettikohtainen
    const [koodiryhmat, setKoodiryhmat] = useState(BuildOptions(lookupLists, "koodiryhmat"));

    useEffect(() => {
        setKoodiryhmat(BuildOptions(lookupLists, "koodiryhmat"));
    }, [lookupLists]);

    const handleClearData = () => {
        setOpen(false);
        setConfirmOpen(false);
        setJotainMuuttui(false);
    }
    
    const handleSave = () => {
        onAdd(rowData);
        setOpen(false);
        handleClearData();
    }

    const handleChange = name => event => {
        setRowData({
            ...rowData,
            [name]: event.target.value
        });
        setJotainMuuttui(true);
    };

    const handleListChange = name => (event, newValue) => {
        if (newValue != null) {
            setRowData({
                ...rowData,
                [name]: newValue.value
            });
        }
        else {
            setRowData({
                ...rowData,
                [event.target.id]: null
            });
        }
        setJotainMuuttui(true);
    }

    const handleClose = () => {
        if (jotainMuuttui === true) {
            setConfirmOpen(true);
        }
        else {
            setOpen(false);
            setConfirmOpen(false);
        }
    }

    const handleSetOpenCancel = () => {
        setConfirmOpen(false);
    }

    return (
        <React.Fragment>
            <Tooltip title={dictionary.Toolbar.NewRow}>
                <IconButton onClick={() => {
                    setRowData({});
                    setOpen(true);
                }}>
                    <AddIcon />
                </IconButton>
            </Tooltip>

            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>{dictionary.Koodi.Title}</DialogTitle>
                <DialogContent style={{ width: "500px" }}>
                    <div style={{ display: 'flex', paddingTop: "10px" }} >
                        <Autocomplete
                            options={koodiryhmat}
                            style={{ width: '100%' }}
                            onChange={handleListChange("koodiryhmaAvain")}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    required={true}
                                    variant="standard"
                                    label={dictionary.Koodi.Columns[1]}
                                    placeholder={dictionary.TextBoxLabel}
                                />
                            )}
                        />
                    </div>
                    <TextField
                        margin="dense"
                        label={dictionary.Koodi.Columns[2]}
                        type="text"
                        fullWidth
                        value={rowData.koodiNimi || ""}
                        onChange={handleChange("koodiNimi")}
                    />
                    <TextField
                        margin="dense"
                        label={dictionary.Koodi.Columns[3]}
                        type="text"
                        fullWidth
                        value={rowData.koodiNimiEN || ""}
                        onChange={handleChange("koodiNimiEN")}
                    />
                    <TextField
                        margin="dense"
                        label={dictionary.Koodi.Columns[4]}
                        type="text"
                        fullWidth
                        value={rowData.koodiKuvaus || ""}
                        onChange={handleChange("koodiKuvaus")}
                    />
                    <TextField
                        margin="dense"
                        label={dictionary.Koodi.Columns[5]}
                        type="text"
                        fullWidth
                        value={rowData.koodiKuvausEN || ""}
                        onChange={handleChange("koodiKuvausEN")}
                    />
                </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                </DialogActions>
            </Dialog>
            <ConfirmCancelDialog
                open={confirmOpen}
                onCancel={handleSetOpenCancel}
                onOk={handleClearData}
            />
        </React.Fragment>
    );
}